<div class="modal-container" #component>
    <div class="bg_shadow" (click)="close()"></div>
    <div [class]="side">
        <div class="modal-header">
            <div *ngIf="currentLevel === 'first'" class="close" (click)="close()">
                <fun-icon [name]="'x-close'" [style]="'w-32 h-32 stroke-gray-40 stroke-2'"></fun-icon>
            </div>
            <div *ngIf="currentLevel === 'second'" class="close" (click)="close()">
                <fun-icon [name]="'arrow-down'" [style]="'w-32 h-32 stroke-gray-40 stroke-2'"></fun-icon>
            </div>
            <div class="modal-status">
                <h2 class="font-sans text-2xl text-eggplant-100">{{ title }}</h2>
            </div>
            <div class="line"></div>
        </div>
        <div>
            <div #componentPlaceholder></div>
        </div> 
    </div>
</div>